import React from "react";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import FieldLabel from "./FieldLabel";

const useStyles = makeStyles()(() => ({
	hint: {
		fontSize: "12px",
		color: "#6b7280",
		marginTop: "4px",
	},
}));

const DeliveryEmailField = ({ value, onChange, fallbackEmail }) => {
	const { classes } = useStyles();
	return (
		<div>
			<FieldLabel>Delivery Email</FieldLabel>
			<TextField
				name="deliveryEmail"
				variant="outlined"
				fullWidth
				value={value || ""}
				placeholder={fallbackEmail || ""}
				onChange={(e) => onChange(e.target.value)}
			/>
			<Typography className={classes.hint}>
				Leave blank to use your profile email.
			</Typography>
		</div>
	);
};

export default DeliveryEmailField;
